// Define sensitive keys that should not be stored in plain in production
const SENSITIVE_KEYS = ['userInfo'];

const getEnvironment = () => {
  return process.env.REACT_APP__ENV || process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
};

const isProduction = () => {
  const env = getEnvironment();
  return env === 'production' || env === 'staging';
};

const isDevelopment = () => {
  return getEnvironment() === 'development';
};

export const setItem = (key: string, value: string) => {
  if (SENSITIVE_KEYS.includes(key)) {
    if (isDevelopment()) {
      localStorage.setItem(key, value);
    }
    // In production/staging, do not store sensitive data
  } else {
    if (isDevelopment()) {
      localStorage.setItem(key, value);
    } else {
      // Obfuscate with base64
      const obfuscated = btoa(value);
      localStorage.setItem(key, obfuscated);
    }
  }
};

export const getItem = (key: string): string | null => {
  if (SENSITIVE_KEYS.includes(key)) {
    if (isDevelopment()) {
      return localStorage.getItem(key);
    }
    // In production/staging, return null as it's not stored
    return null;
  } else {
    const stored = localStorage.getItem(key);
    if (stored === null) return null;
    if (isDevelopment()) {
      return stored;
    } else {
      // Deobfuscate from base64
      try {
        return atob(stored);
      } catch {
        return null;
      }
    }
  }
};

export const removeItem = (key: string) => {
  localStorage.removeItem(key);
};

export const clear = () => {
  localStorage.clear();
};